import { useState } from "react";
import { faqs } from "@/mocks/positiveNews";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            常见问题 · FAQ
            <span className="h-px w-6 bg-primary-400" />
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">你可能想知道的事</h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-200 bg-primary-50/60" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-base">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  >
                    {isOpen ? "ri-subtract-line" : "ri-add-line"}
                  </i>
                </button>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}